interface LoadingStateProps {
  message?: string;
  compact?: boolean;
  /** 骨架行数（默认 3），用于表格、列表类场景。*/
  rows?: number;
}

/**
 * 加载态。
 *
 * 设计系统（DESIGN.md §8）：
 * - 默认用骨架屏而非 spinner。原因：骨架屏传达"结构即将出现"，
 *   spinner 只传达"等待"；工厂系统数据密集，骨架屏让人更早安心。
 * - 兼容旧 API：compact 时保留旧行为（居中小块），但骨架化，无 spinner。
 */
export default function LoadingState({ message = '加载中...', compact, rows = 3 }: LoadingStateProps) {
  if (compact) {
    return (
      <div className="rounded-md bg-white px-4 py-6 text-center">
        <div className="mx-auto h-3 w-24 animate-pulse rounded-sm bg-pine-100" />
        <div className="mt-2 text-xs text-oak-500">{message}</div>
      </div>
    );
  }

  return (
    <div className="rounded-md border border-birch-200 bg-white p-5 shadow-card">
      <div className="space-y-3">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="flex gap-3">
            <div className="h-4 w-1/4 animate-pulse rounded-sm bg-pine-100" />
            <div className="h-4 flex-1 animate-pulse rounded-sm bg-pine-100" />
            <div className="h-4 w-1/6 animate-pulse rounded-sm bg-pine-100" />
          </div>
        ))}
      </div>
      <div className="mt-4 text-center text-xs text-oak-500">{message}</div>
    </div>
  );
}
